import { Knot } from "../utils/query"
import { sleep } from "../utils/utils";
import AddKnotView from "./AddKnotView"
import TimelineKnotView from "./TimelineKnotView"
import { useQueryClient } from "@tanstack/react-query";


export type NodeTimelineProps = {
    knots: Knot[]
    nodeId: string
    lastElementRef: ((node: HTMLElement | null) => void) | null
    addKnot: (knot: Knot) => Promise<void>
}

export const NodeTimeline = (props: NodeTimelineProps) => {
    const { knots, nodeId, lastElementRef, addKnot } = props

    const queryClient = useQueryClient();

    const handleNewKnot = async (title: string, body: string) => {
        await addKnot({
            id: Math.random().toString(),
            circleId: "1",
            nodeId: nodeId,
            type: "note",
            title: title,
            description: body,
            tags: ["note"],
            timestamp: new Date().toISOString()
        })

        await sleep(100);
        await queryClient.invalidateQueries({ queryKey: ['knots'] });

    }
    return (
        <div>
            <ul className="timeline timeline-snap-icon timeline-compact max-md:timeline-compact timeline-vertical">
                <AddKnotView handleNewKnot={handleNewKnot} />
                {knots.map((knot, i) => {
                    if (knots.length === i + 1) {
                        return (
                            <TimelineKnotView key={knot.id + 1000} knotRef={lastElementRef} index={i} maxLen={knots.length} knot={knot} />
                        )
                    }
                    return <TimelineKnotView key={knot.id + 1000} index={i} maxLen={knots.length} knot={knot} />
                })}
            </ul>
        </div>
    )
}


export default NodeTimeline